import React, { Component } from 'react'

import RidingTable from '../Tables/RidingTable'
import DownloadDataLink from '../Tables/DownloadDataLink'
import TabInterface from '../Tab/TabInterface'
import Tab from '../Tab/Tab'

class ProvincialRidings extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filter: null
    }
    this.applyFilter = this.applyFilter.bind(this)
  }

  applyFilter (filter) {
    this.setState({ filter })
  }

  render () {
    const data = {}

    const ridingSets = ['bc', 'ab', 'sk', 'on', 'qc']

    const ridingIds = ridingSets.map(provCode => `${provCode}-ridings`)

    ridingSets.forEach(key => {
      data[key] = this.props.data.ridings && this.props.data.ridings[key]
        ? Object.values(this.props.data.ridings[key])
        : {}
    })

    return (
      <div>
        <div className='row'>
          <div className='col'>
            <h1>Provincial ridings</h1>
          </div>
        </div>
        <TabInterface>
          <Tab key={1} name='British Columbia'>
            <DownloadDataLink forId={ridingIds[0]} filename={ridingIds[0]} />
            <RidingTable id={ridingIds[0]} ridings={data.bc} />
          </Tab>
          <Tab key={2} name='Alberta'>
            <DownloadDataLink forId={ridingIds[1]} filename={ridingIds[1]} />
            <RidingTable id={ridingIds[1]} ridings={data.ab} />
          </Tab>
          <Tab key={3} name='Saskatchewan'>
            <DownloadDataLink forId={ridingIds[2]} filename={ridingIds[2]} />
            <RidingTable id={ridingIds[2]} ridings={data.sk} />
          </Tab>
          <Tab key={4} name='Ontario'>
            <DownloadDataLink forId={ridingIds[3]} filename={ridingIds[3]} />
            <RidingTable id={ridingIds[3]} ridings={data.on} />
          </Tab>
          <Tab key={5} name='Québec'>
            <DownloadDataLink forId={ridingIds[4]} filename={ridingIds[4]} />
            <RidingTable id={ridingIds[4]} ridings={data.qc} />
          </Tab>
        </TabInterface>
      </div>
    )
  }
}

export default ProvincialRidings



// WEBPACK FOOTER //
// ./src/components/App/ProvincialRidings.js